export const failedAttempts = [
  {
    title: 'Pagar deudas viejas',
    text: 'A menudo BAJA tu score, porque reactiva la fecha de actividad de la cuenta.',
  },
  {
    title: 'Llamar por teléfono a los burós',
    text: 'Les da la prueba que necesitan para mantener la deuda en tu reporte.',
  },
  {
    title: 'Ignorar el problema',
    text: 'Solo hace que los intereses crezcan y que las oportunidades se cierren.',
  },
  {
    title: 'Las apps gratuitas de score',
    text: 'Te dan una cifra aproximada, no lo que el banco realmente ve de ti.',
  },
]

export const deliverables = [
  {
    title: 'La Guía Maestra "Crédito Limpio en 30 Días"',
    text: 'El manual paso a paso, de principio a fin, para limpiar tu reporte por tu cuenta.',
    featured: true,
  },
  {
    title: 'Plantillas de Cartas de Disputa',
    text: 'Listas para llenar con tus datos y enviar por correo certificado.',
    featured: false,
  },
  {
    title: 'Checklist de Auditoría',
    text: 'Para que sepas exactamente qué errores buscar en tu reporte.',
    featured: false,
  },
  {
    title: 'Hacks de Velocidad',
    text: 'La técnica para subir 50 puntos en una semana usando el crédito de otros.',
    featured: false,
  },
  {
    title: 'Guía de Negociación',
    text: 'Qué decir para que borren la deuda a cambio de un pago mínimo.',
    featured: false,
  },
]

export const forYou = [
  'Mujeres que quieren comprar su primera casa en USA.',
  'Personas con colecciones médicas o deudas de tarjetas de crédito viejas.',
  'Recién llegadas que necesitan construir un historial sólido desde cero.',
  'Quien esté cansada de pagar intereses del 20% o más en su auto.',
]

export const notForYou = [
  'Personas que buscan evadir deudas actuales de forma ilegal.',
  'Quienes no están dispuestas a ir al correo a enviar una carta certificada.',
  'Quienes esperan que el crédito se arregle por arte de magia sin actuar.',
]

export const steps = [
  {
    title: 'Descarga',
    text: 'Obtén tu guía y las plantillas de cartas de inmediato, en cuanto completes tu pago.',
  },
  {
    title: 'Identifica',
    text: 'Usa nuestra checklist para marcar, línea por línea, los errores en tu reporte.',
  },
  {
    title: 'Envía',
    text: 'Copia nuestras plantillas, fírmalas y envíalas por correo. ¡Los 30 días empiezan a correr!',
  },
]

export const faqs = [
  {
    question: '¿Es legal hacer esto yo misma?',
    answer:
      'Sí. La ley FCRA te da el derecho exclusivo de disputar tu propia información ante los burós de crédito. Nadie puede hacerlo con más autoridad que tú.',
  },
  {
    question: '¿Cuánto tiempo tarda?',
    answer:
      'Los burós tienen 30 días por ley para responderte desde que reciben tu carta. Por eso enviarla por correo certificado es clave: te da la fecha exacta en que empieza el reloj.',
  },
  {
    question: '¿Tengo que pagar a alguien más?',
    answer:
      'No. Solo el costo de la guía y las estampillas del correo. Sin mensualidades, sin agencias, sin intermediarios.',
  },
]

export const productImage =
  'https://cdn.magicpatterns.com/uploads/4UhxpYGPk7x36BF9b7cVba/private_openrouter-generated-image-1786683909818.png'
